(() => {
  if (window.VAGBoosterMessageFormsLoaded) return;
  window.VAGBoosterMessageFormsLoaded = true;

  const fallbackLabels = {
    'temat': 'Temat',
    'imię': 'Imię',
    'name': 'Name',
    'nazwa': 'Imię',
    'email': 'Email',
    'typ silnika': 'Silnik',
    'typ sterownika': 'Sterownik',
    'usługa': 'Usługa',
    'kod silnika': 'Kod silnika',
    'numer ecu': 'Nr ECU',
    'programator': 'Programator',
    'vin': 'VIN',
    'model auta': 'Auto',
    'marka i model': 'Auto',
    'moc seryjna': 'Moc seryjna',
    'skrzynia': 'Skrzynia',
    'cel': 'Cel',
    'wiadomość': 'Wiadomość',
    'message': 'Message',
    'komentarz': 'Wiadomość',
    'comment': 'Message'
  };

  const cleanLabel = (name) => {
    const match = name.match(/^contact\[(.*)\]$/);
    const raw = (match ? match[1] : name).trim();
    return fallbackLabels[raw.toLowerCase()] || raw;
  };

  const fieldLabel = (form, name) => {
    const field = Array.from(form.elements).find((element) => element.name === name);
    if (field && field.id) {
      const label = form.querySelector('label[for="' + field.id + '"]');
      if (label && label.textContent.trim()) return label.textContent.trim();
    }
    return cleanLabel(name);
  };

  const init = () => {
    document.querySelectorAll('form[data-vb-sms-form], form[data-vb-whatsapp-form]').forEach((form) => {
      if (form.dataset.vbMessageReady === 'true') return;
      form.dataset.vbMessageReady = 'true';

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!form.reportValidity()) return;

        const data = new FormData(form);
        const selectedTopic = String(data.get('contact[temat]') || '').trim();
        const defaultTopic = form.dataset.vbTopic || 'VAGBooster - zapytanie';
        const lines = [selectedTopic ? 'VAGBooster: ' + selectedTopic : defaultTopic];

        for (const [name, rawValue] of data.entries()) {
          if (name === 'contact[temat]' || name === 'form_type' || name === 'utf8') continue;
          const value = String(rawValue).trim();
          if (!value) continue;
          lines.push(fieldLabel(form, name) + ': ' + value);
        }

        const message = encodeURIComponent(lines.join('\n'));
        if (form.hasAttribute('data-vb-whatsapp-form')) {
          const number = form.dataset.whatsappNumber || '48881492556';
          window.location.assign('https://wa.me/' + number + '?text=' + message);
          return;
        }

        const number = form.dataset.smsNumber || '48881492556';
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
          (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        const separator = isIOS ? '&' : '?';
        window.location.assign('sms:+' + number + separator + 'body=' + message);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();